import { render, staticRenderFns } from "./MaskingForm.vue?vue&type=template&id=c4a9f4b2&scoped=true"
import script from "./MaskingForm.vue?vue&type=script&lang=ts"
export * from "./MaskingForm.vue?vue&type=script&lang=ts"
import style0 from "./MaskingForm.vue?vue&type=style&index=0&id=c4a9f4b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4a9f4b2",
  null
  
)

export default component.exports